import React, {useState} from 'react';
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Button} from "@material-ui/core";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";


const useStyles = makeStyles((theme)=>({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '90%',
        height: '85%',
        overflowY: 'scroll',
        overflowX: 'scroll'
    },
    headerContainer: {
        // display: 'flex',
        // justifyContent: "space-between"
    },
    button: {
        margin: '15px',
    }
}));

// Cap how many rows we render in the preview table. Building a DOM table for
// very large sheets (e.g. Level11 with 170k+ rows) freezes/crashes the browser.
const PREVIEW_ROW_LIMIT = 100;

function ImportPreviewModal(props) {

    const { title, open, rows, cols, handleClose, dataJson, tableReload, postAPI, chunkSize } = props;

    const classes = useStyles();

    const [uploadingData, setUploadingData] = useState(false);
    const [progressText, setProgressText] = useState('');

    const dataUploadAction = async () => {

        setUploadingData(true);

        try {
            // For large datasets, upload in sequential chunks so each request stays
            // well under the server body-size limit and the DB writes stay bounded.
            // defer_cache=true on every chunk except the last makes the heavy
            // full-collection cache refresh run exactly once at the end.
            if (chunkSize && dataJson.length > chunkSize) {
                const total = dataJson.length;
                let done = 0;
                for (let i = 0; i < total; i += chunkSize) {
                    const chunk = dataJson.slice(i, i + chunkSize);
                    const isLast = (i + chunkSize) >= total;
                    await postAPI(chunk, { defer_cache: !isLast });
                    done += chunk.length;
                    setProgressText(`Uploaded ${done} / ${total} rows…`);
                }
                setProgressText('');
                handleClose();
                tableReload();
            } else {
                const result = await postAPI(dataJson);
                handleClose();
                if (result.data && result.data.new_list) {
                    tableReload(result.data.new_list);
                } else {
                    tableReload();
                }
            }
        } catch (e) {
            // already toasted the error
            setProgressText('');
        }

        setUploadingData(false);
    }

    const renderTD = (data) => {
        if (typeof data === 'object') {
            if (Array.isArray(data)) {
                let spans = [];
                for (let item of data) {
                    spans.push(<span>{item}</span>)
                }
                return spans;
            } else {
                return data;
            }
        } else if (typeof data === 'boolean') {
            if (data === true) {
                return 'True'
            } else {
                return 'False'
            }
        } else {
            return data;
        }

    }

    return (

        <>
            <LoaderWithBackDrop loading={uploadingData} />
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.modalPaper}>
                        <div className={classes.headerContainer}>
                            <h2 id="transition-modal-title">{title}</h2>
                            <div>
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    disabled={uploadingData}
                                    onClick={ () => dataUploadAction() }
                                >Upload Data</Button>
                                <span style={{ marginLeft: 8 }}>
                                    {(dataJson && dataJson.length) || rows.length} rows to upload
                                    {progressText ? ` — ${progressText}` : ''}
                                </span>
                            </div>
                            {
                                rows.length > PREVIEW_ROW_LIMIT &&
                                <p style={{ color: '#888', margin: '4px 0' }}>
                                    Showing first {PREVIEW_ROW_LIMIT} of {rows.length} rows. All rows will be uploaded.
                                </p>
                            }

                        </div>


                        <table className="ExcelTable2007">
                            <tbody>
                            <tr>
                                <th />
                                {
                                    cols.map( col =>  <th>{col.name}</th>)
                                }
                            </tr>
                            {
                                rows.slice(0, PREVIEW_ROW_LIMIT).map( (row, index) => <tr>
                                    <td className={'heading'}>{index+1}</td>
                                    {cols.map( (col, ci) =>  <td>{renderTD(row[ci])}</td>)}
                                </tr>)
                            }
                            </tbody>
                        </table>

                    </div>
                </Fade>
            </Modal>
        </>
    );
}

export default ImportPreviewModal;